module.exports = __webpack_public_path__ + "img/ai1@2x.fd50c622.png";